import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import useAuth from 'store/AuthContext'
import Profile from 'components/Icons/profile'
import { ProfileAvatar } from '../Header.style'
import UserService from 'services/UserService'

const UserProfile = ({ isMobile = false, onClick }) => {
  const { setLoginModalShow, auth, user } = useAuth()
  const [isSsoEnabled, setIsSsoEnabled] = React.useState(null)

  const handleClick = e => {
    if (auth) {
      if (onClick) onClick(e)
      return
    }
    e.preventDefault()
    if (isSsoEnabled === null) {
      // still loading, maybe show a spinner
      return
    }

    isSsoEnabled === 1 ? redirectToAuthService() : setLoginModalShow(true)
  }

  useEffect(() => {
    UserService.featureFlags().then(data => {
      setIsSsoEnabled(data['sso-auth'])
    })
  }, [])

  const redirectToAuthService = () => {
    const returnPath = window.location.pathname + window.location.search
    localStorage.setItem('postAuthRedirect', returnPath)
    const authServiceBaseUrl = process.env.REACT_APP_AUTH_SERVICE_URL

    const authServiceUrl = `${authServiceBaseUrl}/login?ref=${encodeURIComponent(
      window.location.origin
    )}`

    window.location.href = authServiceUrl
  }

  const avatarContent = auth ? (
    user.name.charAt(0).toUpperCase()
  ) : (
    <Profile
      width={isMobile ? 22 : 20}
      height={isMobile ? 22 : 20}
      color="white"
      className="mb-[1px] md:mb-0"
    />
  )
  const userName = auth ? user.name : 'პროფილი'

  const mobileStyles = 'cursor-pointer'
  const desktopStyles =
    'flex items-center gap-2 py-2 px-3 bg-slate-50 rounded-full border border-slate-200 text-sm text-slate-700 cursor-pointer'

  if (isMobile) {
    return (
      <Link to="/account/orders" onClick={handleClick} className={mobileStyles}>
        <ProfileAvatar>{avatarContent}</ProfileAvatar>
      </Link>
    )
  }

  return (
    <Link to="/account/orders" onClick={handleClick} className={desktopStyles}>
      <ProfileAvatar>{avatarContent}</ProfileAvatar>
      <span>{userName}</span>
    </Link>
  )
}

export default UserProfile
